
import "../style/PrivacyPolicy.css";
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        <button className="back-link" onClick={() => navigate('/')}>
          ← Вернуться на главную
        </button>
        
        <header className="policy-header">
          <div className="policy-badge">Юридическая информация</div>
          <h1 className="policy-title">Политика конфиденциальности</h1>
          <p className="policy-updated">Последнее обновление: 21 декабря 2025 г.</p>
        </header>

        <div className="policy-grid">
          <aside className="policy-nav">
            <nav>
              <ul>
                <li><a href="#section1">1. Сбор данных</a></li>
                <li><a href="#section2">2. Цели обработки</a></li>
                <li><a href="#section3">3. Третьи лица</a></li>
                <li><a href="#section4">4. Защита и сроки</a></li>
                <li><a href="#section5">5. Ваши права</a></li>
              </ul>
            </nav>
          </aside>

          <main className="policy-content">
            <section id="section1" className="policy-block">
              <h2>1. Сбор информации</h2>
              <p>
                Мы придерживаемся принципа минимизации данных. Собираются только те сведения, которые необходимы для исполнения требований законодательства Кыргызской Республики и прохождения процедуры <strong>KYC (Know Your Customer)</strong>.
              </p>
              <div className="data-list">
                <span>• Биометрические данные (фотографии)</span>
                <span>• Паспортные данные</span>
                <span>• Контактная информация</span>
              </div>
            </section>

            <section id="section2" className="policy-block">
              <h2>2. Цели использования</h2>
              <p>Ваши данные обрабатываются исключительно в следующих целях:</p>
              <ul>
                <li>Идентификация личности для обеспечения безопасности транзакций;</li>
                <li>Соблюдение регламентов по противодействию отмыванию доходов (AML);</li>
                <li>Предотвращение мошеннических операций и несанкционированного доступа.</li>
              </ul>
            </section>

            <section id="section3" className="policy-block">
              <h2>3. Конфиденциальность и передача</h2>
              <div className="guarantee-box">
                <p>
                  <strong>Безопасность прежде всего:</strong> Мы гарантируем, что ваши персональные данные <u>никогда не будут проданы</u> или переданы рекламным агентствам.
                </p>
              </div>
              <p>
                Раскрытие информации возможно только по официальному запросу государственных органов в рамках законодательства КР.
              </p>
            </section>

            <section id="section4" className="policy-block">
              <h2>4. Хранение и защита</h2>
              <p>
                Все данные шифруются с использованием современных протоколов защиты. Срок хранения составляет <strong>5 (пяти) лет</strong>, что соответствует нормам законодательства Кыргызской Республики.
              </p>
            </section>

            <section id="section5" className="policy-block">
              <h2>5. Права пользователя</h2>
              <p>Вы имеете полное право на:</p>
              <ul>
                <li>Доступ к своим персональным данным и получение их копии;</li>
                <li>Исправление неточностей в профиле;</li>
                <li>Отозвать согласие (с учетом ограничений, накладываемых финансовым правом КР).</li>
              </ul>
            </section>

            <footer className="policy-footer">
              <p>Есть вопросы? Напишите нам в поддержку через раздел контактов.</p>
            </footer>
          </main>
        </div>
      </div>
    </div>
  );
}